export const DEMO_REQUEST_VALIDATION_RULES = {
    first_name: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 255}},
    last_name: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 255}},
    email: {presence: {allowEmpty: false}, email: true},
    website: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 1000}},
    business_segment: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 100}},
    business_subsegment: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 255}},
    what_data: {presence: {allowEmpty: false}, length: {minimum: 10}},
    what_for: {presence: {allowEmpty: false}, length: {minimum: 10}},
    est_volume: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 1000}},
    location: {presence: {allowEmpty: false}, length: {minimum: 1, maximum: 1000}},
    phone: {length: {maximum: 50}},
    terms_and_conditions: {presence: {allowEmpty: false}},
};
